export default import.meta.ROLLDOWN_FILE_URL_xtZ9zJA9SM2UEmQzLKsBiw